import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import TeacherCombo from '../combos/TeacherCombo';
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Col, Form, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import StudentSelector from '../school/StudentSelector';
import EmployeeSelector from '../school/EmployeeSelector';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import ShowVideo from '../shared/ShowVideo';



export default function SendSms(props) {
    const toast = useRef(null);
    const [error, setError] = useState({ visible: false, message: "" });
    const [saving, setSaving] = useState(false);
    const [targets, setTargets] = useState([]);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [studentSelectorVisible, setStudentSelectorVisible] = useState(false);
    const [teacherSelectorVisible, setTeacherSelectorVisible] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [onlyParent, setOnlyParent] = useState(false);

    const [message, setMessage] = useState("");
    const [mobile, setMobile] = useState("");
    const [create, setCreate] = useState(true);

    

    useEffect(() => {
    }, []);
    const checkDataEntry = function(){
      if(message == null || message == ""){
        setError({ visible: true, message: "متن پیام را مشخص نمائید" });
        return false;
      }
      if(targets == null){
        setError({ visible: true, message: "هیچ مخاطبی انتخاب نشده است" });
        return false;
      }
      if(targets.length == 0){
        setError({ visible: true, message: "هیچ مخاطبی انتخاب نشده است" });
        return false;
      }
      return true;
    }

    const saveItem = function(){
      if(!checkDataEntry()) return;
      var mobiles = [];
      for(var i=0;i<targets.length;i++) mobiles.push(targets[i].mobile);
      var params = {
        login:util.getTrustedUser(), 
        message:message,
        mobiles:mobiles,
      };
      var url = config.Server+`/school/sms/by-single/send`;
      if(create) url = config.Server+`/school/mobile-sms/by-single/create`;
      console.log("params to replace is>", params)
      
      setSaving(true);
        axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                toast.current.show({ severity: 'info', summary: 'Info', detail: 'با موفقیت ارسال شد' });              
                setSaving(false);
              }
              else{
                setError({ visible: true, message: response.message });
                  setSaving(false);
              }
          })
          .catch(error => {
            setError({ visible: true, message: error.code + "," + error.message });
              setSaving(false);
          });

    }
  const onRowDeleteClick = function(mobile){
    setTargets(prev => prev.filter(t => t.mobile !== mobile));
  }
  const setRowActions = function (mobile) {
    return (
            <Row className="justify-content-md-center" style={{}}>
              <Button icon="pi pi-trash" rounded severity="danger" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => {onRowDeleteClick(mobile)}} title="حذف" />
            </Row>
    );
  }
  const getMobileInd = function(mobile){
    for(var i=0;i<targets.length;i++){
      if(targets[i].mobile == mobile) return i;
    }
    return -1;
  }
  const onAcceptSelectedStudentDialog = function(students){
    var tmp = [...targets];
    for(var i=0;i<students.length;i++){
      if(getMobileInd(students[i].mobile) >=0) continue;
      tmp.push({mobile:students[i].mobile, firstname:students[i].firstname, lastname:students[i].lastname, nationalId:students[i].nationalId});
    }
    setTargets(tmp);
    setStudentSelectorVisible(false);
  }

  const onAcceptSelectedTeacherDialog = function(teachers){
    var tmp = [...targets];
    console.log("teachers>", teachers)
    for(var i=0;i<teachers.length;i++){
      if(getMobileInd(teachers[i].user.mobile) >=0) continue;
      tmp.push({mobile:teachers[i].user.mobile, firstname:teachers[i].user.firstname, lastname:teachers[i].user.lastname, nationalId:teachers[i].user.nationalId});
    }
    setTargets(tmp);
    setTeacherSelectorVisible(false);
  }
  const addMobileNo = function(){
    if(!util.IsMobileValid(mobile)){
      setError({ visible: true, message: "شماره نامعتبر است" });
      return;
    }
    if(getMobileInd(mobile) >=0) {
      setError({ visible: true, message: "شماره قبلا به لیست اضافه شده است" });
      return;
    }
    var tmp = [...targets];
    tmp.push({mobile:mobile, firstname:"", lastname:"", nationalId:""});
    setTargets(tmp);
    setMobile("");
    setEditFormVisible(false);
  }
  const editDialogFooter = function () {
    return (
      <GeneralDialogFooter onOkClick={() => { addMobileNo() }} onCancelClick={() => { setEditFormVisible(false) }} saving={saving} />
    )
  }
  return(      
      (redirectUrl != "")
          ?
          <Navigate to={redirectUrl} replace={false}  />
      :
      <>
      <ShowVideo videoId="school_send_sms" top={65} md={6} /> 
         <Row style={{paddingTop:"0px", margin:"5px", border:"1px solid #b0b0b0", borderRadius:"5px"}}>
            <Col md={12} style={{backgroundColor:"royalblue", color:"#FFFFFF",padding:"5px", borderRadius:"5px", fontSize:"14pt"}}>
                ارسال پیامک
            </Col>
            <Row style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
              <Col md={12}>
                متن پیام:
                <br></br>
                <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setMessage(e.target.value)}} value={message} />
              </Col>
            </Row>
            <Row style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
              <Col md={12} style={{backgroundColor:"#d8f3d7ff", padding:"3px 0px", margin:"5px 10px", width:"calc(100% - 20px)"}}>
                  <div className="flex align-items-center" style={{marginTop:"10px", marginBottom:"10px"}}>
                      <Checkbox inputId={"chk_2"} onChange={(e)=>{setCreate(e.checked)}} checked={create} />
                      <label htmlFor={"chk_2"} className="ml-2"> &nbsp;پیامک با پنل ارسال نشود. می خواهم با موبایل خودم ارسال کنم</label>
                  </div>                
                    <div>
                      اگر گزینه فوق را تیک بزنید پیامک توسط پنل اینترنی ارسال نمی شود. 
                            در این حالت پیامک دخیره شده و می توانید با کمک اپلیکیشن کلاسیکو7 آنرا ارسال نمائید و موجب کاهش هزینه ارسال پیامک به نرخ همراه اول یا ایرانسل گردد. 
                    </div>
              </Col>
            </Row>
            <Row  style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
              <Col md={12}>
                  <Row style={{}}>
                    <Col md={12}>
                      <div style={{width:"60px", padding:"2px", border:"1px solid #b0b0b0", borderRadius:"5px", margin:"5px", float:"right",textAlign:"center", height:"70px", position:"relative"}}>
                        <label style={{fontSize:"7pt"}}>دانش آموز</label>
                        <img onClick={()=>{setOnlyParent(false); setStudentSelectorVisible(true);}} src={require('../lib/images/student.png')} style={{width:"40px", cursor:"pointer", borderRadius:"5px", position:"absolute", left:"10px", bottom:"1px"}} title='افزودن دانش آموز' />
                      </div>
                      <div style={{width:"60px", padding:"2px", border:"1px solid #b0b0b0", borderRadius:"5px", margin:"5px", float:"right",textAlign:"center", height:"70px", position:"relative"}}>
                        <label style={{fontSize:"7pt"}}>والدین</label>
                        <img onClick={()=>{setOnlyParent(true); setStudentSelectorVisible(true);}} src={require('../lib/images/parent.png')} style={{width:"40px", cursor:"pointer", borderRadius:"5px", position:"absolute", left:"10px", bottom:"1px"}} title='افزودن والدین' />
                      </div>
                      <div style={{width:"60px", padding:"2px", border:"1px solid #b0b0b0", borderRadius:"5px", margin:"5px", float:"right",textAlign:"center", height:"70px", position:"relative"}}>
                        <label style={{fontSize:"7pt"}}>همکار</label>
                        <img onClick={()=>{setTeacherSelectorVisible(true);}} src={require('../lib/images/teacher.png')} style={{width:"40px", cursor:"pointer", borderRadius:"5px", position:"absolute", left:"10px", bottom:"1px"}} title='افزودن همکار' />
                      </div>
                      <div onClick={()=>{setEditFormVisible(true);}} style={{width:"60px", padding:"2px", border:"1px solid #b0b0b0", borderRadius:"5px", margin:"5px", float:"right",textAlign:"center", height:"70px", position:"relative"}}>
                        <label style={{fontSize:"7pt"}}>شماره آزاد</label>
                        <img src={require('../lib/images/mobile.png')} style={{width:"40px", cursor:"pointer", borderRadius:"5px", position:"absolute", left:"10px", bottom:"1px"}} title='افزودن شماره آزاد' />
                      </div>
                    </Col>
                  </Row>
                  <div className="page-caption">لیست مخاطبین</div>

                <DataTable value={targets} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                  dataKey="id" selection={null} onSelectionChange={(e) => { }}>
                  <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                  {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                  <Column field="mobile" body={(row) => row.mobile} header={"موبایل"} sortable className="list-cell-text-align"></Column>
                  <Column field="firstname" body={(row) => row.firstname} header={"نام"} sortable className="list-cell-text-align"></Column>
                  <Column field="lastname" body={(row) => row.lastname} header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                  <Column field="nationalId" body={(row) => row.nationalId} header={"کدملی"} sortable className="list-cell-text-align"></Column>
                  <Column body={(row) => setRowActions(row.mobile)} exportable={false} style={{ maxWidth: '6rem' }}></Column>
                </DataTable>
              </Col>
            </Row>
            
            
            <Row style={{margin :"20px 0px"}}>
              <Col md={3}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                    <Button label={(create?"ایجاد":"ارسال") +" پیامک(ها)"} icon="pi pi-check" onClick={()=>saveItem(true)} severity="success" iconPos="right" loading={saving} />                    
                  </div>
              </Col>
            </Row>
         </Row>
          {
          studentSelectorVisible? <StudentSelector onlyFreeStudent={false} onlyParent={onlyParent} degree={-1} fieldId={""} onAccept={(students)=>onAcceptSelectedStudentDialog(students)} onClose={()=>{setStudentSelectorVisible(false)}}/>:<></>
          }
          {
          teacherSelectorVisible? <EmployeeSelector onAccept={(teachers)=>onAcceptSelectedTeacherDialog(teachers)} onClose={()=>{setTeacherSelectorVisible(false)}}/>:<></>
          }
          {
            editFormVisible ?
              <Dialog visible={true} style={{ width: '30rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="ثبت شماره موبایل" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => {setEditFormVisible(false)}}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                      <td style={{ padding: "1px" }}>
                        <FloatLabel>
                          <InputText value={mobile} onChange={(e) => { setMobile(e.target.value) }} id="mobile" keyfilter="int" maxLength={11} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                          <label htmlFor="username">شماره موبایل</label>
                        </FloatLabel>
                      </td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                  </tbody>
                </table>

              </Dialog>
              :
              <></>
          }
          <ShowError visible={error.visible} message={error.message} closeError={()=>{setError({visible:false, message:""})}} />
          <Toast ref={toast} />            
      </>  
    );
  
}
